import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'addProject.form.title',
    defaultMessage: 'Create New Project',
  },
  name: {
    id: 'addProject.form.name.label',
    defaultMessage: 'Name',
  },
  nameErrorIsRequired: {
    id: 'editProject.form.name.error.isRequired',
    defaultMessage: 'Name is required.',
  },
  description: {
    id: 'addProject.form.description.label',
    defaultMessage: 'Description',
  },
  owner: {
    id: 'addProject.form.owner.label',
    defaultMessage: 'Project Owner',
  },
  ownerSecondary: {
    id: 'addProject.form.owner.label.secondary',
    defaultMessage: 'Email',
  },
  ownerPlaceholder: {
    id: 'addProject.form.ownerPlaceholder.label',
    defaultMessage: 'Email Address',
  },
  ownerTooltip: {
    id: 'addProject.form.ownerTooltip.label',
    defaultMessage: 'If blank will default to account email.',
  },
  optional: {
    id: 'addProject.form.optional.label',
    defaultMessage: 'Optional',
  },
  genomeBuild: {
    id: 'addProject.form.genomeBuild.label',
    defaultMessage: 'Genome Reference Build (cannot be changed later)',
  },
  genomeBuildSimple: {
    id: 'addProject.form.genomeBuildSimple.label',
    defaultMessage: 'Genome Reference Build',
  },
  part11Label: {
    id: 'addProject.form.part11Label',
    defaultMessage:
      'This project requires 21 CFR Part 11 compliance. This cannot be changed later!',
  },
  genomeBuildGRCh37: {
    id: 'addProject.form.genomeBuildGRCh37.label',
    defaultMessage: 'GRCh37',
  },
  genomeBuildGRCh38: {
    id: 'addProject.form.genomeBuildGRCh38.label',
    defaultMessage: 'GRCh38',
  },
  submitButton: {
    id: 'addProject.form.buttons.submit',
    defaultMessage: 'Add',
  },
  cancel: {
    id: 'addProject.form.buttons.cancel',
    defaultMessage: 'Cancel',
  },
  addSuccess: {
    id: 'addProject.request.successMessage',
    defaultMessage: 'Successfully added project',
  },
  addFailure: {
    id: 'addProject.request.failureMessage',
    defaultMessage: 'Failed to add project',
  },
  complianceLabel: {
    id: 'addProject.form.complianceLabel',
    defaultMessage: 'FDA Compliance',
  },
  complianceLabelHelp: {
    id: 'addProject.form.complianceLabelHelp',
    defaultMessage: 'Enable FDA 21 CFR Part 11 compliance for this project.',
  },
  auditLogging: {
    id: 'addProject.form.auditLogging',
    defaultMessage: 'Audit Trail',
  },
  auditLoggingHelp: {
    id: 'addProject.form.auditLoggingHelp',
    defaultMessage: 'Enable the audit trail for this project.',
  },
  shortNameLabel: {
    id: 'addProject.form.shortnameLabel',
    defaultMessage: 'Short Name',
  },
  shortNameHelp: {
    id: 'addProject.form.shortNameHelp',
    defaultMessage:
      'An assignable, human-readable identifier for this project. {warning}',
  },
  shortNameHelpWarning: {
    id: 'addProject.form.shortNameHelpWarning',
    defaultMessage: 'Once it is set it may not be changed',
  },
  shortNameTaken: {
    id: 'addProject.form.shortNameTaken',
    defaultMessage:
      'Short name "{shortName}" is already taken by another project in this account',
  },
  creationError: {
    id: 'addProject.form.creationError',
    defaultMessage: 'There was an error creating this project',
  },
  creationSuccess: {
    id: 'addProject.form.creationError',
    defaultMessage: 'Successfully created project {project}',
  },
  mrnConfig: {
    id: 'addProject.form.mrnConfig',
    defaultMessage: 'Medical Record Number (MRN) Customization',
  },
  mrnConfigTypeCoding: {
    id: 'addProject.form.mrnConfigTypeCoding',
    defaultMessage: 'Type Coding',
  },
  mrnConfigSystem: {
    id: 'addProject.form.mrnConfigSystem',
    defaultMessage: 'System',
  },
  mrnConfigCode: {
    id: 'addProject.form.mrnConfigCode',
    defaultMessage: 'Code',
  },
  generateGroupAndPolicyLabel: {
    id: 'addProject.form.generateGropuAndPolicyLabel',
    defaultMessage: 'Generate User Group and Security Policy',
  },
  generateGroupAndPolicyDescription: {
    id: 'addProject.form.generateGropuAndPolicyDescription',
    defaultMessage:
      'Creates a default security policy that grants read/write/delete/update access',
  },
});
